import React from 'react';
import { ApolloError } from '@apollo/client';
import { useTranslation } from '@shared/core';
import { SpacingStack, TextV2 } from '@withjoy/joykit';
import { JoyLogo } from '@shared/createEvent/JoyLogo';

import { Centered, StaticJoyLogoLoader } from './TyingTheKnotContainer.styles';
import { HelpCenterLink } from './components/HelpCenterLink';

interface TyingTheKnotContainerProps {
  error?: ApolloError;
}

export const TyingTheKnotContainer: React.FC<TyingTheKnotContainerProps> = ({ error }) => {
  const { t, t2 } = useTranslation('createEvent');
  const { loadingText } = t2('tyingTheKnot');
  const generalError = t('tyingTheKnot').errorText({ HelpCenter: HelpCenterLink });
  return (
    <Centered>
      <SpacingStack spacing={8} paddingX={7} alignItems="center">
        {!error && (
          <>
            <StaticJoyLogoLoader loaderKey="tying-the-knot-container" />
            <TextV2 textAlign="center" typographyVariant="hed3">
              {loadingText}
            </TextV2>
          </>
        )}
        {error && (
          <>
            <JoyLogo />
            <TextV2 textAlign="center" typographyVariant="hed3" maxWidth={'360px'}>
              {generalError}
            </TextV2>
          </>
        )}
      </SpacingStack>
    </Centered>
  );
};
